'use strict';

import angular from 'angular';

export default class SignupController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {};
  submitted = false;
  error = false;
  errorMessage = '';


  /*@ngInject*/
  constructor(FB, $state, $http, fetch, $scope, baseConfigService) {
    this.FB = FB;
    this.$state = $state;
    this.$http = $http;
    this.fetch = fetch;
    this.$scope = $scope;
    this.baseConfigService = baseConfigService;
  }

  $onInit(){
    this.getJurisdictionList();
  }

  getJurisdictionList(){
    this.fetch.getAllItems('api/data/jurisdictions/list')
    .then(response => {

      this.$scope.jurisdictions = response.data;
    })
    .catch(err => {
      console.log(err);
    })

}

  isMetroEmail(email) {
    if (!email) return false;
    return email.toLowerCase().endsWith('@bayareametro.gov');
  }

  register(form) {
    console.log(form);
    this.submitted = true;
    var user = {
      firstname: this.user.firstname,
      lastname: this.user.lastname,
      email: this.user.email,
      password: this.user.password,
      organization: this.user.organization
    }
    if (form.$valid) {

      // check if email already exists
      this.$http.get(`${this.baseConfigService.getAdminBaseURL()}/users/check-email/${user.email}`)
        .then(response => {
          if (response.status === 200) {
            // Email already exists
            this.error = true;
            this.errorMessage = 'An account with this email already exists. Please use a different email or contact support to reset your password.';
          } else {
            //
            this.error = true;
            this.errorMessage = 'Error with checking email. Please try again.';
            return true;

          }
        })
        .catch(err => {
          console.log(err);
          if (err.status === 404) {
            // Email not found, proceed with registration
            return this.FB.createUser(user)
              .then((data) => {
                console.log(data);
                // Account created, redirect to home
                this.error = false;
                this.errorMessage = '';
                this.$state.go('register-success');
              })
              .catch(err => {
                console.log(err);
                err = err.data || err;
                this.errors = {};
                this.error = true;
                this.errorMessage = err.message || 'An error occurred during registration. Please try again.';

                // Update validity of form fields that match the sequelize errors
                // if(err.name) {
                //   angular.forEach(err.fields, (error, field) => {
                //     form[field].$setValidity('mongoose', false);
                //     this.errors[field] = err.message;
                //   });
                // }
              });
          } else {
            this.error = true;
            this.errorMessage = 'An unexpected error occurred. Please try again.';
          }
        });
    } else {
      this.error = true;
      this.errorMessage = 'Please fill in all required fields.';
    }
  }

  ssoLogin(form) {
    this.$scope.savingSSO = true;
    const adminBaseURL = this.baseConfigService.getAdminBaseURL();

    try {
      // Store current URL before redirect
      const currentUrl = window.location.href;
      const returnUrl = `${window.location.origin}/login`; // Updated return URL

      // Store the current URL as return URL
      sessionStorage.setItem('loginRedirectUrl', currentUrl);

      // Redirect to Azure login with return URL
      setTimeout(() => {
        // Add return URL to login endpoint
        // const loginUrl = `${adminBaseURL}/login?redirect_uri=${encodeURIComponent(returnUrl)}`;
        const loginUrl = `${adminBaseURL}/login?redirect_uri=${encodeURIComponent(returnUrl)}&frontend_url=${encodeURIComponent('http://localhost:3000')}`;
        // const loginUrl = `${adminBaseURL}/login?redirect_uri=${encodeURIComponent(returnUrl)}&frontend_url=${encodeURIComponent('https://localhost:3000')}`;
        console.log('Redirecting to:', loginUrl); // Debug line
        window.location.href = loginUrl;
      }, 500);

    } catch (err) {
      this.$scope.savingSSO = false;
      console.error('SSO redirect error:', err);
      this.errors = {
        login: 'Failed to initiate SSO login. Please try again.'
      };
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.js